import { formatUnits, parseUnits } from 'viem';

/**
 * Converts a human-readable amount to bigint with given decimals
 *
 * @param {string | number} amount - The human-readable amount (e.g., "1.5")
 * @param {number} decimals - Number of decimals for the token (e.g., 18 for ETH, 6 for USDT)
 * @returns {bigint}
 */
export const toBigIntWithDecimals = (amount, decimals) => {
  let newAmount;
  if (typeof amount !== 'string') {
    newAmount = amount.toString();
  }

  return parseUnits(newAmount, decimals);
};

/**
 * Converts an on-chain bigint amount to a human-readable string with given decimals
 *
 * @param {bigint} amount - The raw on-chain bigint value
 * @param {number} decimals - The number of decimals used by the token (e.g., 18 for ETH, 6 for USDT)
 * @returns {string}
 */
export const fromBigIntWithDecimals = (amount, decimals) => {
  return formatUnits(amount, decimals);
};
